import videoStatus from 'utils/videoStatusUtils';
import { CountModal } from './Modal';
import { format } from 'date-fns';
import videoTableVisibility from 'utils/videosTableVisibility';

const imageStyle = { width: '23px', height: '28px' };

export const defaultColumns = [
  {
    field: 'select',
    type: 'expanded',
    with: '63px',
    maxWidth: '63px',
    align: 'left',
  },
  {
    field: 'version',
    label: 'Versão',
    align: 'center',
    render: (value, row) => {
      const status = row?.status?.toString()?.toUpperCase?.() ?? '';
      const previousVersions = (row?.previousVersions ?? [])
        .map(item => item?.video?.status?.toString()?.toUpperCase?.() ?? '')
        .filter(Boolean);

      const hasPublished = previousVersions.includes('PUBLISHED');
      const hasDraft = previousVersions.includes('DRAFT');
      const isFailed = ['FAILED', 'EXPIRED', 'FAILED_UPLOAD'].includes(status);

      // Regras de cor
      const backgroundColor =
        status === 'PUBLISHED'
          ? '#98FB98' // verde (publicada atual)
          : status === 'DRAFT'
            ? '#FFFF8F' // amarelo (rascunho atual)
            : isFailed && !hasPublished && !hasDraft
              ? '#FF7F7F' // vermelho (falhou e não há pub/draft anteriores)
              : // versões anteriores
                hasPublished
                ? '#98FB98'
                : '#D3D3D3';
      return (
        <div
          style={{
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
          }}>
          <div
            className={
              value === undefined
                ? 'datatable_prevent_click'
                : 'video_datatable_version'
            }
            style={{ backgroundColor }}>
            {value === undefined ? '-' : value}
          </div>
        </div>
      );
    },
  },

  { field: 'buttons', type: 'actions-videos', align: 'center' },
  { field: 'title', label: 'Título', align: 'left' },
  {
    field: 'status',
    label: 'Status',
    render: value => videoStatus?.[value] || '-',
  },
  {
    field: 'visibility',
    label: 'Visibilidade',
    render: value => videoTableVisibility?.[value] || '-',
  },
  { field: 'totalViews', label: 'Visualizações' },
  {
    field: 'viewsLimit',
    label: 'Limite de Players',
    render: value => (value === 0 ? 'Ilimitado' : value),
  },
  {
    field: 'createdBy',
    label: 'Criado por',
    render: value => value?.name || '-',
  },
  {
    field: 'updatedBy',
    label: 'Editado por',
    render: value => value?.name || '-',
  },
  {
    field: 'updatedAt',
    label: 'Última atualização',
    render: value =>
      value ? format(new Date(value), 'HH:mm dd/MM/yyyy') : '-',
  },
  {
    field: 'publishedAt',
    label: 'Data da publicação',
    render: value => (value ? format(new Date(value), 'dd/MM/yyyy') : '-'),
  },
  {
    field: 'expiresIn',
    label: 'Data limite de veiculação',
    render: value =>
      value ? format(new Date(value), 'dd/MM/yyyy') : 'Sem data limite',
  },
  {
    field: 'personalitiesCredits',
    label: 'Crédito (Personalidade)',
    render: (value, row) => (
      <CountModal
        title="Personalidades associadas"
        description={`O vídeo "${row.title}" está associado as seguintes personalidades (Crédito):`}
        listIcon={
          <img
            src="/img/navbar_cockpit/personalidade_icon.svg"
            alt="Personalidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: 'personalities',
    label: 'Com Quem (Personalidade)',
    render: (value, row) => (
      <CountModal
        title="Personalidades associadas"
        description={`O vídeo "${row.title}" está associado as seguintes personalidades (Com Quem?):`}
        listIcon={
          <img
            src="/img/navbar_cockpit/personalidade_icon.svg"
            alt="Personalidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: 'keywords',
    label: 'Palavras-Chave',
    render: (value, row) => (
      <CountModal
        title="Palavras-Chave associadas"
        description={`O vídeo "${row.title}" está associado as seguintes palavras-chave:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/palavras_chave_icon.svg"
            alt="Palavras-chave Associadas"
            style={imageStyle}
          />
        }
        list={value?.map(v => {
          v.name = (
            <div className="filtered_content_main">
              <div className="filtered_content_title">{v.key}: </div>
              <div className="filtered_content_content">({v.value})</div>
            </div>
          );
          return v;
        })}
      />
    ),
  },
  {
    field: 'collections',
    label: 'Coleção',
    align: 'center',
    render: (value, row) => (
      <CountModal
        title="Coleções associadas"
        description={`O vídeo "${row.title}" está associado as seguintes coleções:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/colecoes_icon.svg"
            alt="Coleções Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: 'units',
    label: 'Unidade',
    render: (value, row) => (
      <CountModal
        title="Unidades associadas"
        description={`O vídeo "${row.title}" está associado as seguintes unidades:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/unidades_sesc_icon.svg"
            alt="Unidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: 'channels',
    label: 'Canal',
    render: (value, row) => (
      <CountModal
        title="Canais associados"
        description={`O vídeo "${row.title}" está associado aos seguintes canais:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/canais_sesc_icon.svg"
            alt="Canais Associados"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
];
